const companyWorkerKey = ['admin', 'companyWorker'] as const

export const companyWorkerKeys = {
  all: companyWorkerKey,
}
